var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgDocumentsi = function SvgDocumentsi(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: props.color || 'currentColor',
    d: "M6 21a2.01 2.01 0 0 1-2-2.015v-9.16l4.175-4.237h7.169a2.01 2.01 0 0 1 2 2.015v11.382a2.01 2.01 0 0 1-2 2.015zm-.5-2.015a.507.507 0 0 0 .5.515h9.346a.506.506 0 0 0 .5-.515V7.6a.506.506 0 0 0-.5-.515H9.295v3.047a.75.75 0 0 1-.75.751H5.5zm1.1-9.6h1.2V8.168zm11.241 8.355a.75.75 0 0 1 .487-.943.26.26 0 0 0 .175-.246V4.757a.254.254 0 0 0-.25-.257H8.414a.25.25 0 0 0-.241.186.75.75 0 0 1-.924.52.75.75 0 0 1-.519-.924A1.754 1.754 0 0 1 8.411 3h9.839A1.756 1.756 0 0 1 20 4.757v11.791a1.75 1.75 0 0 1-1.22 1.675.7.7 0 0 1-.227.036.75.75 0 0 1-.715-.522z",
    "data-name": "Union 113"
  }));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDocumentsi);
export default ForwardRef;